import React from "react";
import { CommonCellRenderers, ExternalLink } from "@netapp/bxp-design-system-react";
import { Trans, useTranslation } from "react-i18next";
import { AGENT_TROUBLESHOOTING_GUIDE_URL } from "utils/app/constants";
import { connectors as i18nNamespace } from "../../../../i18n/namespace";

const localizedStatus = (status, t) => {
    return status ? t(status.toLowerCase()) : t('unknown');
};

const AgentStatusRenderer = ({ value }) => {
    const { t } = useTranslation(i18nNamespace);
    
    const localizedValue = localizedStatus(value, t);
    
    const getTooltipForRow = () => {
        const isUnreachable = [t("inactive"), t("pending"), t("unknown")].includes(localizedValue);
        if (isUnreachable) {
            return <Trans 
                i18nKey="console_agent_unreachable_message" 
                t={t} 
                components={{ 
                    learnMoreLink: <ExternalLink variant="text" href={AGENT_TROUBLESHOOTING_GUIDE_URL} includeArrow={true}/>
                }} 
            />
        }
    };
    
    const StatusComponent = CommonCellRenderers.StatusRenderer({
        [t("active")]: "on",
        [t("inactive")]: "off", 
        [t("pending")]: "loading",
        [t("failed")]: "failed",
        [t("unknown")]: "warning"
    }, getTooltipForRow());
    
    return <StatusComponent value={localizedValue} />;
};

export default AgentStatusRenderer;
